export const DEFAULT_ORDER_COLOR = '#D24747'